<template>
  <div ref="container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    excludeClasses: {
      type: Array,
      default: () => []
    }
  },
  emits: ["click-outside"],
  mounted() {
    setTimeout(() => {
      document.addEventListener("click", this.handleClickOut);
    });
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOut);
  },
  methods: {
    handleClickOut(e) {
      const excludeClasses = this.$props.excludeClasses || [];
      if (
        !window.$.contains(this.$refs.container, e.target) &&
        !e.target.className
          .split(" ")
          .some((elClass) => excludeClasses.includes(elClass))
      ) {
        this.$emit("click-outside");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
